import { userStore } from '@/store';

/**
 * 金融機関支店管理者判定
 */
export const isBranchAdmin = (): boolean => {
  return userStore.loginUser.user_type === 'branch_admin';
};
